/*
  Carousel accessibility fix — Peaceful Media, July 2026.

  Flickity marks non-selected slides aria-hidden="true" but leaves the links and
  buttons inside them in the tab order. Keyboard and screen-reader users can
  therefore tab into content that has been hidden from the accessibility tree —
  the axe-core "aria-hidden-focus" violation. Measured 12 occurrences on the
  homepage (quiz-carousel-item x5, single-carousel-product x7).

  This keeps tabindex in sync with aria-hidden: focusable descendants of a hidden
  slide leave the tab order, and are restored exactly as they were when the slide
  becomes current again. Purely additive — no visual or behavioural change, and
  scoped to Flickity so it cannot affect drawers, modals or app markup.
*/
(function () {
  var FOCUSABLE = 'a[href], button, input, select, textarea, iframe, [tabindex]';
  var STASH = 'data-a11y-tabindex';

  function sync(cell) {
    if (!cell || cell.nodeType !== 1) return;
    var hidden = cell.getAttribute('aria-hidden') === 'true';
    var nodes = cell.querySelectorAll(FOCUSABLE);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (hidden) {
        // Remember the original value once, so repeated slide changes can't clobber it.
        if (!el.hasAttribute(STASH)) {
          el.setAttribute(STASH, el.hasAttribute('tabindex') ? el.getAttribute('tabindex') : '');
        }
        el.setAttribute('tabindex', '-1');
      } else if (el.hasAttribute(STASH)) {
        var prev = el.getAttribute(STASH);
        if (prev === '') el.removeAttribute('tabindex');
        else el.setAttribute('tabindex', prev);
        el.removeAttribute(STASH);
      }
    }
  }

  function syncAll() {
    var cells = document.querySelectorAll('.flickity-slider > [aria-hidden]');
    for (var i = 0; i < cells.length; i++) sync(cells[i]);
  }

  function start() {
    syncAll();

    // Flickity toggles aria-hidden as the carousel moves. attributeFilter keeps this
    // cheap — the browser only calls back for the one attribute we care about.
    if (window.MutationObserver) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var t = muts[i].target;
          if (t.closest && t.closest('.flickity-slider')) sync(t);
        }
      }).observe(document.body, {
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-hidden']
      });
    }

    // Carousels initialise asynchronously and at different times. A few short passes
    // catch late inits without leaving a timer running for the life of the page.
    var passes = 0;
    var iv = setInterval(function () {
      syncAll();
      if (++passes >= 6) clearInterval(iv);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
